import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Badge, Card, OptionDropdown, Grid, Tabs, ODataTable, Formatter, Dropdown, Panel, Highlighter, Button, PopOver,
} from 'framework-ui-components';
import SuccessoIcon from 'framework-ui-components/Components/Icons/SuccessoIcon';
import { SnackbarWrapper as SnackbarManager } from 'framework-ui-components/Components/Snackbar';
import { InputRicerca, PageWrapper } from 'dashboard';
import {
  totali7304, stampaBarra4, stampaLetteraPrecontrolli, stampaLetteraDiniego, stampaContribuenti7304,
} from 'apis/setteTrentaApi';
import TipoDichiarazione from 'enums/TipoDichiarazione';
import Servizi from 'enums/Servizi';
import { setAnnoSelezionato } from '../../actions/dichiarativiActions';
import EventoServer from '../../libs/EventoServer';

import DettaglioBarra4 from './DettaglioBarra4';
import { bindActionCreators } from '../../../node_modules/redux';
import checkServizio from '../../helpers/checkServizio';
import ExcelIcon from '../../components/Icons/ExcelIcon';

const INITIAL_TAB_INDEX = 0;

const RigaSostituto = ({ additionalRowData, item }) => (
  <tr key={item.IdDichiarazione} onClick={(e) => window.location.href = `/#/SetteTrenta/Sostituto/${item.CodiceFiscale}/${item.Nome.replace('/', '')}`}>
    <td>
      <Highlighter text={item.Nome} value={additionalRowData.searchTerm} />
    </td>
    <td>{item.CodiceFiscale}</td>
    <td className="text--right">{item.Trasmessi}</td>
    <td className="text--right">{item.EsitoPositivo}</td>
    <td className="text--right">{item.PreControlli}</td>
    <td className="text--right">{item.Scarti}</td>
  </tr>
);

function stampaTipo(tipo) {
  switch (tipo) {
    case TipoDichiarazione.SetteTrentaIntegrativaCodice1:
      return '1';
    case TipoDichiarazione.SetteTrentaIntegrativaCodice2:
      return '2';
    case TipoDichiarazione.SetteTrentaIntegrativaCodice3:
      return '3';
    default:
      return '';
  }
}

const CODICEFISCALEINPS = '80078750587';

function stampaStato(item) {
  if (item.DatiAddizionali.CodiceFiscaleSostitutoImposta != ''
    && (item.Anno > 2019 || item.DatiAddizionali.CodiceFiscaleSostitutoImposta != CODICEFISCALEINPS)
    && (item.DatiAddizionali.DaTrattenere7304 == '0' && item.DatiAddizionali.DaRimborsare7304 == '0')) {
    return 'Importi a zero';
  } if (item.DatiAddizionali.CodiceFiscaleSostitutoImposta == '') {
    return 'Senza sostituto';
  } if ((item.DatiAddizionali.DaTrattenere7304 != '0' || item.DatiAddizionali.DaRimborsare7304 != '0') && item.DatiAddizionali.Stato7304 == 'NonImpostato') {
    return 'Inviato A.E.';
  } if (item.DatiAddizionali.SenzaSostituto == 'False'
    && (item.Anno > 2019 || item.DatiAddizionali.CodiceFiscaleSostitutoImposta != CODICEFISCALEINPS) && item.DatiAddizionali.Stato7304 == 'Ok') {
    return "Reso disponibile al sostituto d'imposta";
  } if (item.DatiAddizionali.Stato7304 == 'Precontrolli') {
    return 'Controllo preventivo';
  } if (item.DatiAddizionali.CodiceFiscaleSostitutoImposta !== CODICEFISCALEINPS && item.DatiAddizionali.Stato7304 == 'ScartoAE' && item.DatiAddizionali.Stato7304Info == 'NO' && item.DatiAddizionali.DataInvioPostel == '') {
    return 'Non disponibile';
  } if (item.DatiAddizionali.CodiceFiscaleSostitutoImposta !== CODICEFISCALEINPS && item.DatiAddizionali.Stato7304 == 'ScartoAE' && item.DatiAddizionali.Stato7304Info == 'NO' && item.DatiAddizionali.DataInvioPostel != '') {
    return 'Postel';
  } if ((item.DatiAddizionali.Stato7304 == 'ScartoAE' && (item.DatiAddizionali.Stato7304Info == 'CF' || item.DatiAddizionali.Stato7304Info == 'CV'))) {
    return 'Scartato Sostituto';
  } if (item.DatiAddizionali.Stato7304 == 'ScartoInps') {
    return 'Scartato I.N.P.S.';
  } if (item.DatiAddizionali.Stato7304 == 'Ok' && item.DatiAddizionali.CodiceFiscaleSostitutoImposta == CODICEFISCALEINPS) {
    return "Abbinata dall'I.N.P.S.";
  }
  return '';
}

class RigaContribuente extends Component {
  state = {
    mostraModaleDettaglio: false,
  }

  stampa = () => {
    const { item } = this.props;
    stampaBarra4([item]).then((resp) => {
      if (!resp.Success) {
        SnackbarManager.notifyError(resp.DetectedProblems);
      } else {
        SnackbarManager.startDeterminateAsyncTask(resp.CorrelationId, 'Creazione pdf in corso', 1);
        this.setState({
          stampaInCorso: true,
        });
      }
    });
  }

  apriDettaglio = () => {
    this.setState({
      mostraModaleDettaglio: true,
    });
  }

  chiudiModaleDettaglio = () => {
    this.setState({
      mostraModaleDettaglio: false,
    });
  }

  stampaLetteraControlli = () => {
    const { item } = this.props;

    const stato = {
      IdDichiarazione: item.IdDichiarazione,
      CodiceUfficio: item.CodiceUfficio,
      Anno: item.Anno,
    };

    stampaLetteraPrecontrolli(stato)
      .then((resp) => {
        if (!resp.Success) {
          this.setState({
            messaggioErroreStampa: resp.DetectedProblems,
            isLoadingModaleStampa: false,
          });
        } else {
          SnackbarManager.startDeterminateAsyncTask(resp.CorrelationId, 'Creazione pdf in corso', 1);
          this.setState({
            stampaInCorso: true,
          });
        }
      });
  }

  stampaLetteraDiniego = () => {
    const { item } = this.props;

    const stato = {
      IdDichiarazione: item.IdDichiarazione,
      CodiceUfficio: item.CodiceUfficio,
      Anno: item.Anno,
    };

    stampaLetteraDiniego(stato)
      .then((resp) => {
        if (!resp.Success) {
          this.setState({
            messaggioErroreStampa: resp.DetectedProblems,
            isLoadingModaleStampa: false,
          });
        } else {
          SnackbarManager.startDeterminateAsyncTask(resp.CorrelationId, 'Creazione pdf in corso', 1);
          this.setState({
            stampaInCorso: true,
          });
        }
      });
  }

  render() {
    const {
      additionalRowData,
      item,
    } = this.props;
    const {
      mostraModaleDettaglio,
    } = this.state;

    return (
      <tr key={item.CodiceFiscale}>
        <td>
          <Highlighter text={item.Dichiarante} value={additionalRowData.searchTerm} />
        </td>
        <td><Highlighter text={item.CodiceFiscale} value={additionalRowData.searchTerm} /></td>
        <td><Highlighter text={item.DatiAddizionali.DenominazioneSostitutoImposta} value={additionalRowData.searchTerm} /></td>
        <td>{item.DatiAddizionali.Congiunta == 'True' && <SuccessoIcon className="icon-success" />}</td>
        {additionalRowData.tabNr == 2 && <td> {item.DatiAddizionali.LetteraPrecontrolliStampata == 'True' && <SuccessoIcon className="icon-success" />}</td>}
        <td>{stampaTipo(item.Tipo)}</td>
        {additionalRowData.tabNr != 2 && <td> {stampaStato(item)}</td>}
        <td className="text--right">{item.DatiAddizionali.Rate7304}</td>
        <td className="text--right">&euro; {item.DatiAddizionali.DaTrattenere7304}</td>
        <td className="text--right">&euro; {item.DatiAddizionali.DaRimborsare7304}</td>
        <td><Formatter tipo="date" valore={item.DatiAddizionali.DataTrasmissione} /></td>
        <td>
          <OptionDropdown>
            {item.DatiAddizionali.CodiceFiscaleSostitutoImposta !== CODICEFISCALEINPS && item.DatiAddizionali.DenominazioneSostitutoImposta != '' && item.DatiAddizionali.Stampa7304Abilitata === 'True' && <OptionDropdown.Item onClick={this.stampa}>Stampa 730/4</OptionDropdown.Item>}
            <OptionDropdown.Item onClick={this.apriDettaglio}>Dettaglio</OptionDropdown.Item>
            {additionalRowData.tabNr == 2 && <OptionDropdown.Item onClick={this.stampaLetteraControlli}>Stampa lettera controlli preventivi</OptionDropdown.Item>}
            {item.DatiAddizionali.Stato7304 && item.DatiAddizionali.Stato7304 == 'Precontrollo' && <OptionDropdown.Item onClick={this.stampaLetteraControlli}>Stampa lettera controlli preventivi</OptionDropdown.Item>}
            {item.DatiAddizionali.CodiceFiscaleSostitutoImposta !== CODICEFISCALEINPS
              && item.DatiAddizionali.Stato7304 === 'ScartoAE' && (item.DatiAddizionali.Stato7304Info == 'CF' || item.DatiAddizionali.Stato7304Info == 'CV')
              && (item.Tipo == TipoDichiarazione.Ordinaria || item.Tipo == TipoDichiarazione.SetteTrentaIntegrativaCodice2)
              && <OptionDropdown.Item onClick={this.stampaLetteraDiniego}>Stampa lettera diniego</OptionDropdown.Item>}
          </OptionDropdown>
        </td>
        <DettaglioBarra4
          idDichiarazione={item.IdDichiarazione}
          showModal={mostraModaleDettaglio}
          onChiudi={this.chiudiModaleDettaglio}
          annoSelezionato={item.Anno}
        />
      </tr>
    );
  }
}

class SetteTrenta4 extends Component {
  state = {
    dichiarazioni: [],
    searchTerm: '',
    selezionati: [],
    tabSelezionato: INITIAL_TAB_INDEX,
    nSostituti: 0,
    nContribuenti: 0,
    nPreControlli: 0,
    nScartati: 0,
  }

  componentDidMount() {
    EventoServer.subscribe('StampaDichiarazioneCompletata', this.ricaricaTabella);
  }

  componentWillUnmount() {
    EventoServer.unsubscribe('StampaDichiarazioneCompletata', this.ricaricaTabella);
  }

  componentWillMount() {
    this.caricaStati(this.props.ufficioSelezionato.CodiceUfficio, this.state.searchTerm, this.props.annoSelezionato);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.ufficioSelezionato.CodiceUfficio != nextProps.ufficioSelezionato.CodiceUfficio) {
      this.inputRicerca && this.inputRicerca.svuotaRicerca(false);
      this.setState({
        searchTerm: '',
      });
      this.caricaStati(nextProps.ufficioSelezionato.CodiceUfficio, '', this.props.annoSelezionato);
    }
  }

  onClickCerca = (searchTerm) => {
    this.setState({ searchTerm: searchTerm.trim() }, () => {
      this.tabellaDichiarazioni && this.tabellaDichiarazioni.loadPage();
      this.caricaStati(this.props.ufficioSelezionato.CodiceUfficio, searchTerm.trim(), this.props.annoSelezionato);
    });
  }

  caricaStati = (studio, searchTerm, anno) => {
    totali7304(studio, anno, searchTerm)
      .then((x) => {
        this.setState({
          nSostituti: x.Sostituti,
          nContribuenti: x.Contribuenti,
          nPreControlli: x.PreControlli,
          nScartati: x.Scartati,
        });
      });
  }

  impostaAnnoSelezionato = (data) => {
    if (data.Anno >= 2021) {
      window.location.hash = '/NewSetteTrenta/barra-quattro';
    } else {
      this.ricaricaTabella();
    }

    this.props.setAnnoSelezionato(data.Anno);
  }

  ricaricaTabella = () => {
    setTimeout(() => {
      this.dataTable && this.dataTable.loadPage();
      this.caricaStati(this.props.ufficioSelezionato.CodiceUfficio, this.state.searchTerm.trim(), this.props.annoSelezionato);
    }, 100);
  }

  setTabSelezionato = (index) => {
    this.setState({
      tabSelezionato: index,
    });
  }

  esportaTutti = () => {
    const {
      ufficioSelezionato,
      annoSelezionato,
    } = this.props;

    const baseUrl = 'SetteTrenta/StampaContribuenti7304';

    stampaContribuenti7304(baseUrl, annoSelezionato, ufficioSelezionato.CodiceUfficio);
  }

  render() {
    const {
      ufficioSelezionato,
      utente,
      anniRegistrati,
      annoSelezionato,
      servizioAttivo,
      accessoNonConsentito,
    } = this.props;
    const {
      tabSelezionato,
      selezionati,
      searchTerm,
      nSostituti,
      nContribuenti,
      nPreControlli,
      nScartati,
    } = this.state;

    const badgeConteggio = (count) => (count != 0 ? <Badge info>{count}</Badge> : null);
    const badgeConteggioScartate = (count) => (count != 0 ? <Badge alarm>{count}</Badge> : null);

    let anniRegistratiFiltrato = anniRegistrati;
    if (window.config.ufficiAbilitatiPreRilascio != '*') {
      // se la chiave contiene dei valori significa che voglio abilitare l'anno solo per alcuni uffici
      let vediSeAbilitare = false;
      window.config.ufficiAbilitatiPreRilascio.split(',').forEach((element) => {
        if (ufficioSelezionato.CodiceUfficio == element) {
          vediSeAbilitare = true;
        }
      });
      if (vediSeAbilitare == false) {
        anniRegistratiFiltrato = anniRegistrati.filter((x) => x.Anno != 2020);
        if (annoSelezionato == 2020) {
          this.props.setAnnoSelezionato(2019);
        }
      }
    }

    return (
      <PageWrapper
        helmetTitle="730-4"
        pageTitle={(
          <div className="w-300">
            <div className="w-140 floatLeft mr-8">
              <span>730-4 </span>
            </div>
            <div className="floatLeft">
              <Dropdown title={annoSelezionato} toggleComponent={<div className="SelettoreAnno"> {annoSelezionato} <span className="dropdown__caret--open" /></div>}>
                {
                  anniRegistratiFiltrato.map((x) => (
                    <Dropdown.Item key={x.Anno} onClick={() => this.impostaAnnoSelezionato(x)}>{x.Anno}</Dropdown.Item>))
                }
              </Dropdown>
            </div>
          </div>
        )}
      >
        <Grid fluid className="pl-0 pr-0">
          <Grid.Row>
            <Grid.Col md="12">
              <Card
                title={<Fragment><span> Lista 730/4</span></Fragment>}
                multipleActions={(
                  <PopOver left content="Esporta in excel tutti i /4 del Cod. Ufficio">
                    <Button floating onClick={this.esportaTutti}> <ExcelIcon style={({ width: '36px', height: '36px' })} /></Button>
                  </PopOver>
                )}
              >
                <Grid.Row>
                  <Grid.Col md="5">
                    <InputRicerca onClickCerca={this.onClickCerca} ref={(r) => this.inputRicerca = r} />
                    {!servizioAttivo && !accessoNonConsentito && <Panel error>Il servizio non è attivo. L'accesso è permesso solo in consultazione</Panel>}
                  </Grid.Col>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Col md="12">
                    <Tabs initialIndex={INITIAL_TAB_INDEX} onSelect={this.setTabSelezionato} index={tabSelezionato}>
                      <Tabs.Tab title={<span>Sostituti {badgeConteggio(nSostituti)}</span>}>
                        <ODataTable
                          hover
                          clickable
                          url={`/SetteTrenta/CercaSostituti7304?searchTerm=${searchTerm}&ufficio=${ufficioSelezionato.CodiceUfficio}&anno=${annoSelezionato}`}
                          row={RigaSostituto}
                          ref={(r) => this.dataTable = r}
                          pageSize={10}
                          availablePageSizes={[10, 20, 50]}
                          additionalRowData={{ searchTerm, tabNr: tabSelezionato }}
                        >
                          <ODataTable.Column>Nome</ODataTable.Column>
                          <ODataTable.Column className="w-180">Codice Fiscale</ODataTable.Column>
                          <ODataTable.Column className="text--right">Trasmessi</ODataTable.Column>
                          <ODataTable.Column className="text--right">Esito Positivo</ODataTable.Column>
                          <ODataTable.Column className="text--right">Controlli preventivi</ODataTable.Column>
                          <ODataTable.Column className="text--right">Scartati</ODataTable.Column>
                        </ODataTable>
                      </Tabs.Tab>

                      <Tabs.Tab title={<span>Contribuenti {badgeConteggio(nContribuenti)}</span>}>
                        <ODataTable
                          hover
                          url={`/SetteTrenta/CercaContribuenti7304?searchTerm=${searchTerm}&ufficio=${ufficioSelezionato.CodiceUfficio}&anno=${annoSelezionato}`}
                          row={RigaContribuente}
                          ref={(r) => this.dataTable = r}
                          pageSize={10}
                          availablePageSizes={[10, 20, 50]}
                          additionalRowData={{ searchTerm, tabNr: tabSelezionato, aggiorna: this.ricaricaTabella }}
                          annoSelezionato={this.props.annoSelezionato}
                        >
                          <ODataTable.Column>Dichiarante</ODataTable.Column>
                          <ODataTable.Column className="w-180">CF Dichiarante</ODataTable.Column>
                          <ODataTable.Column>Sostituto</ODataTable.Column>
                          <ODataTable.Column>Congiunta</ODataTable.Column>
                          <ODataTable.Column>Int.</ODataTable.Column>
                          <ODataTable.Column>Stato</ODataTable.Column>
                          <ODataTable.Column className="text--right">Rateazione</ODataTable.Column>
                          <ODataTable.Column className="text--right">Trattenuto</ODataTable.Column>
                          <ODataTable.Column className="text--right">Rimborsato</ODataTable.Column>
                          <ODataTable.Column>Data Trasmissione A.E.</ODataTable.Column>
                          <ODataTable.Column className="w-40" />
                        </ODataTable>
                      </Tabs.Tab>

                      <Tabs.Tab title={<span>Controlli preventivi {badgeConteggio(nPreControlli)}</span>}>
                        <ODataTable
                          hover
                          url={`/SetteTrenta/CercaContribuentiPrecontrolli7304?searchTerm=${searchTerm}&ufficio=${ufficioSelezionato.CodiceUfficio}&anno=${annoSelezionato}`}
                          row={RigaContribuente}
                          ref={(r) => this.dataTable = r}
                          pageSize={10}
                          availablePageSizes={[10, 20, 50]}
                          additionalRowData={{ searchTerm, tabNr: tabSelezionato }}
                        >
                          <ODataTable.Column>Dichiarante</ODataTable.Column>
                          <ODataTable.Column className="w-180">CF Dichiarante</ODataTable.Column>
                          <ODataTable.Column>Sostituto</ODataTable.Column>
                          <ODataTable.Column>Congiunta</ODataTable.Column>
                          <ODataTable.Column>Stampata</ODataTable.Column>
                          <ODataTable.Column>Int.</ODataTable.Column>
                          <ODataTable.Column className="text--right">Rateazione</ODataTable.Column>
                          <ODataTable.Column className="text--right">Trattenuto</ODataTable.Column>
                          <ODataTable.Column className="text--right">Rimborsato</ODataTable.Column>
                          <ODataTable.Column>Data Trasmissione A.E.</ODataTable.Column>

                          <ODataTable.Column className="w-40" />
                        </ODataTable>
                      </Tabs.Tab>

                      <Tabs.Tab title={<span>Scartati/Postel {badgeConteggioScartate(nScartati)}</span>}>
                        <ODataTable
                          hover
                          url={`/SetteTrenta/CercaContribuentiScartati7304?searchTerm=${searchTerm}&ufficio=${ufficioSelezionato.CodiceUfficio}&anno=${annoSelezionato}`}
                          row={RigaContribuente}
                          ref={(r) => this.dataTable = r}
                          pageSize={10}
                          availablePageSizes={[10, 20, 50]}
                          additionalRowData={{ searchTerm, tabNr: tabSelezionato }}
                        >
                          <ODataTable.Column>Dichiarante</ODataTable.Column>
                          <ODataTable.Column className="w-180">CF Dichiarante</ODataTable.Column>
                          <ODataTable.Column>Sostituto</ODataTable.Column>
                          <ODataTable.Column>Congiunta</ODataTable.Column>
                          <ODataTable.Column>Int.</ODataTable.Column>
                          <ODataTable.Column>Stato</ODataTable.Column>
                          <ODataTable.Column className="text--right">Rateazione</ODataTable.Column>
                          <ODataTable.Column className="text--right">Trattenuto</ODataTable.Column>
                          <ODataTable.Column className="text--right">Rimborsato</ODataTable.Column>
                          <ODataTable.Column>Data Trasmissione A.E.</ODataTable.Column>

                          <ODataTable.Column className="w-40" />
                        </ODataTable>
                      </Tabs.Tab>
                    </Tabs>
                  </Grid.Col>
                </Grid.Row>
              </Card>
            </Grid.Col>
          </Grid.Row>
        </Grid>
      </PageWrapper>
    );
  }
}

const mapStoreToProps = (store) => ({
  ufficioSelezionato: store.utente.ufficioSelezionato,
  utente: store.utente.profilo,
  anniRegistrati: store.dichiarativi.anniRegistrati.data,
  annoSelezionato: store.dichiarativi.annoSelezionato,
});

const mapDispatchToProps = (dispatch) => ({
  setAnnoSelezionato: bindActionCreators(setAnnoSelezionato, dispatch),
});

SetteTrenta4.propTypes = {
  ufficioSelezionato: PropTypes.object,
  utente: PropTypes.object,
};

export default checkServizio(Servizi['7OL'])(connect(mapStoreToProps, mapDispatchToProps)(SetteTrenta4));
